import { createAuthClient, createAuthConfig, LocalStorageRefreshTokenStore } from '@volee/auth'

// Back office sign-in is `auth.password`, no hosted UI, on apps/frontend's pool. Why it deviates
// from docs/design/frontend-v1.md §5: apps/admin-panel/docs/login-sta-dentro-il-prodotto.md
export const auth = createAuthClient({
  config: createAuthConfig(window.location.origin),
  refreshTokenStore: new LocalStorageRefreshTokenStore(),
})
